import type { StandardType } from './task-init-api';

/**
 * TS 搜索请求参数
 */
export interface TsSearchRequest {
    /**
     * TS 编号（支持模糊搜索）
     */
    ts_number: string;
    /**
     * 页码
     */
    page?: number;
    /**
     * 每页数量
     */
    page_size?: number;
    /**
     * 标准类型
     */
    standard_type?: StandardType;
}

/**
 * TS 搜索结果项
 */
export interface TsSearchItem {
    /**
     * 标准 ID
     */
    std_id: string;
    /**
     * 标准编号
     */
    number: string;
    /**
     * 版本
     */
    version: string;
    /**
     * 标题
     */
    title: string;
    /**
     * 项目
     */
    project: string[];
    /**
     * 工作组
     */
    work_group: string;
    /**
     * 发布版本
     */
    release: string[];
}

/**
 * TS 搜索响应
 */
export interface TsSearchResponse {
    /**
     * 请求状态
     */
    status: boolean;
    /**
     * 错误代码
     */
    error_code: number;
    /**
     * 错误消息
     */
    error_msg?: string;
    /**
     * 响应数据
     */
    data?: {
        /**
         * TS 列表
         */
        ts_list: TsSearchItem[];
        /**
         * 总数
         */
        total: number;
        /**
         * 当前页码
         */
        page: number;
        /**
         * 每页数量
         */
        page_size: number;
    };
}

/**
 * TS 版本查询请求参数
 */
export interface TsVersionsRequest {
    /**
     * TS 编号
     */
    ts_number: string;
    /**
     * 标准类型
     */
    standard_type?: StandardType;
}

/**
 * TS 版本信息
 */
export interface TsVersionItem {
    /**
     * 标准 ID
     */
    std_id: string;
    /**
     * 版本
     */
    version: string;
    /**
     * 发布版本
     */
    release: string[];
    /**
     * 标题
     */
    title: string;
    /**
     * 项目
     */
    project: string[];
    /**
     * 工作组
     */
    work_group: string;
    /**
     * 版本日期
     */
    version_date?: string;
}

/**
 * TS 版本查询响应
 */
export interface TsVersionsResponse {
    /**
     * 请求状态
     */
    status: boolean;
    /**
     * 错误代码
     */
    error_code: number;
    /**
     * 错误消息
     */
    error_msg?: string;
    /**
     * 响应数据
     */
    data?: {
        /**
         * TS 编号
         */
        ts_number: string;
        /**
         * 版本列表
         */
        versions: TsVersionItem[];
    };
}

export const TsSearchApi = Symbol('TsSearchApi');

/**
 * TS 搜索 API
 */
export interface TsSearchApi {
    /**
     * 搜索 TS
     */
    searchTs(request: TsSearchRequest): Promise<TsSearchResponse>;

    /**
     * 获取 TS 的所有版本
     */
    getTsVersions(request: TsVersionsRequest): Promise<TsVersionsResponse>;
}
